import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux'
import { Button, Input } from 'reactstrap';
import { Link } from "react-router-dom";
import { PageTitle, Table, TableButtons, CreateButton, CronTaskHistory } from '../../../components';
import matchSorter from 'match-sorter';
import 'react-table-6/react-table.css'
import { loadCronTasks, updateCronTask, duplicateCronTask } from '../../../redux/modules/cron_tasks';
import cronstrue from 'cronstrue';
import 'cronstrue/locales/fr';
import 'cronstrue/locales/de';

import './CronTasksList.css';

const CronTasksList = () => {
    const { t, i18n } = useTranslation();
    const dispatch    = useDispatch();

    const { duplicatedCronTask, isLoadingOne } = useSelector(state => state.cron_tasks);

    useEffect(() => {
        dispatch(loadCronTasks());
    }, [dispatch, duplicatedCronTask]);

    const onDuplicate = (cron_task) => {
        dispatch(duplicateCronTask(cron_task));
    }

    const enable = task => {
        task.enabled = true;
        dispatch(updateCronTask(task));
    }

    const disable = task => {
        task.enabled = false;
        dispatch(updateCronTask(task));
    }

    const { cron_tasks } = useSelector(state => state.cron_tasks);

    const textFilter = ({ filter, onChange }) =>
        <Input
            type="text"
            onChange={event => onChange(event.target.value)}
        />;
    const textOrIdFilterMethod = (filter, rows) => matchSorter(rows, filter.value, { keys: ["name", "_id"] });

    const columns = [{
        Header: t("cron_tasks.name"),
        accessor: "name",
        filterMethod: textOrIdFilterMethod,
        Filter: textFilter,
        filterAll: true,
        Cell: row => (
            <>
                <div className="d-flex justify-content-between p-1">
                    <Link to={`/cron_tasks/edit/${row.original._id}`}>
                        <div className="name-cell">
                            {row.original.name}
                        </div>
                    </Link>

                    {!row.original.enabled && (
                        <div className="badge badge-danger">
                            { t('cron_tasks.this_task_is_disabled') }
                        </div>
                    )}
                </div>
                <div className="name-subcell p-1 d-flex justify-content-between">
                    { t('cron_tasks.nb_executions', {nb: row.original.nbExecutions() }) }
                    {row.original.enabled ? (
                        <Button size="xs" color="danger" onClick={() => disable(row.original)}>
                            <i className={`fa fa-${ isLoadingOne ? 'spinner fa-spin' : 'stop'}`} />&nbsp;
                            { t('cron_tasks.disable_this_task') }
                        </Button>
                    ) : (
                        <Button size="xs" color="success" onClick={() => enable(row.original)}>
                            <i className={`fa fa-${ isLoadingOne ? 'spinner fa-spin' : 'play'}`} />&nbsp;
                            { t('cron_tasks.enable_this_task') }
                        </Button>
                    )}
                </div>
            </>
        )
    }, {
        Header: t("cron_tasks.frequency"),
        accessor: "frequency",
        filterable: false,
        Cell: row => (
            <div>
                { cronstrue.toString(row.original.frequency, {locale: i18n.language}) }
                <div className="w-100">
                    <CronTaskHistory history={row.original.history} />
                </div>
            </div>
        )
    }, {
        Header: t("common.actions"),
        accessor: "_id",
        maxWidth: 110,
        filterable: false,
        Cell: row => (
            <TableButtons
                id={row.value}
                actions={["edit", "delete", "duplicate"]}
                module="cron_tasks"
                onDuplicate={() => onDuplicate(row.original)}
            />
        )
    }];

    const actions =
        <CreateButton
            module="cron_tasks"
            text="cron_tasks.add"
        />

    const title =
        <span>{t("cron_tasks.cron_task_plural")}</span>

    return (
        <div className="CronTasksList">
            <PageTitle icon="tasks" title={title} actions={actions} />
            <Table id="bucketListsTable" data={cron_tasks} columns={columns} />
        </div>
    );
}

export default CronTasksList;
